import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Tab,
  Typography,
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import ReportTemplates from "./ReportTemplates";
import GenerateReports from "./GenerateReports";
import MuiButton from "../../components/muiButton/MuiButton";
import DatePicker from "../../components/dateRangePickerComponent/DateRangePicker";
import { format } from "date-fns";

function InfluencerReports() {
  const [tabValue, setTabValue] = React.useState("1");
  const tabHandleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // REPORT GENERATION variables and functions
  const [selectedReports, setSelectedReports] = useState([]);

  let templateReports = [
    "Total Influencers",
    "Total Activities per Influncers",
    "Total Influencers per Category",
    "Total Influencers per geo location",
    "Total Influencers in each platform",
    "Agent wise Activity Reports",
    "All Influencer Agent wise",
    "Total Campagins per platforms",
    "Total Activities per Campagins",
    "Total Campaigns per Category",
    "Total Campaigns per geo location",
    "Total Campagins",
  ];

  // Tickets fields checkboxes rendering
  const reportsCheckbox = templateReports
    ? templateReports.map((option) => {
        return (
          <Grid item xl={12} container md={3}>
            <FormControlLabel
              control={
                <Checkbox
                  value={option}
                  label={option}
                  onChange={ReportTemplatehandleChange}
                  checked={selectedReports.includes(option)}
                />
              }
              label={option}
            />{" "}
          </Grid>
        );
      })
    : null;

  function ReportTemplatehandleChange(event) {
    const value = event.target.value;

    if (selectedReports.indexOf(value) !== -1) {
      // if value already present
      const newSelected = selectedReports.filter((s) => s !== value);
      setSelectedReports(newSelected);
    } else {
      // if value not present
      setSelectedReports([...selectedReports, value]);
    }
  }
  const [date, setDate] = React.useState([null, null]);

  const dateValueHandleChange = (e, v) => {
    setDate([e[0] && e[0].$d, e[1] && e[1].$d]);
  };

  const CustomDateFilter = () => {
    return `["created_on","must","lte","range","${format(
      date[1],
      "yyyy-MM-dd"
    )}"],["created_on","must","gte","range","${format(
      date[0],
      "yyyy-MM-dd"
    )}"]`;
  };

  const [filterArray, setFilterArray] = useState([]);

  const applyFilter = () => {
    let filters = [];
    if (date[0] !== null && date[1] !== null) {
      filters.push(CustomDateFilter());
    }

    setFilterArray(filters);
  };

  const ClearState = () => {
    if (date[0] !== null || date[1] !== null) {
      setDate([null, null]);
      setFilterArray([]);
    }
  };

  return (
    <Grid container lg={12}>
      <Grid container item lg={12} sm={12} md={12} gap={2}>
        <Grid item lg={3} sm={3} md={3}>
          <DatePicker value={date} onChange={dateValueHandleChange} />
        </Grid>

        <Grid sx={{ display: "flex", justifyContent: "end" }}>
          <MuiButton name={"Filter"} onClick={applyFilter} />
          <MuiButton name={"Clear"} onClick={ClearState} />
        </Grid>
      </Grid>

      <Grid sx={{ width: "100%", marginBottom: 1.5 }}>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1 }}>
            <TabList
              onChange={tabHandleChange}
              aria-label="lab API tabs example"
            >
              <Tab
                sx={{ border: "none" }}
                label="Create Report Templates"
                value="1"
              />
              <Tab sx={{ border: "none" }} label="Generate Report" value="2" />
            </TabList>
          </Box>

          {/* <TabPanel
            value="1"
            sx={{
              padding: "5px",
              height: "auto",
              width: "100%",
            }}
          >
            <ReportTemplates
              listItem={reportsCheckbox}
              selected={selectedReports}
              filterArray={filterArray}
            />
          </TabPanel> */}
          {/* <TabPanel
            value="2"
            sx={{
              padding: "5px",
              height: "auto",
              width: "100%",
            }}
          >
            <GenerateReports
              listItem={reportsCheckbox}
              selected={selectedReports}
              filterArray={filterArray}
            />
          </TabPanel> */}
        </TabContext>
      </Grid>
    </Grid>
  );
}

export default InfluencerReports;
